/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Stats_ValidInputs */



/**
* | output |
* | --- |
* | "Valid Keys" |
*
* @param {Api_Keys_Stats_ValidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const api_keys_stats_valid = /** @type {((inputs?: Api_Keys_Stats_ValidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Stats_ValidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gültige Schlüssel")
	return /** @type {LocalizedString} */ ("Valid Keys")
});